import { Button } from 'antd';
import classNames from 'classnames';
import { ForwardedRef, forwardRef } from 'react';
import { useTranslation } from 'react-i18next';

import { REFRIGERATOR_OPTIONS } from '@common/enums';

export interface RefrigeratorOptionsProps {
    refrigeratorSelectedOption?: REFRIGERATOR_OPTIONS;
    onOptionSelect: (option: REFRIGERATOR_OPTIONS) => void;
}

export const RefrigeratorOptions = (
    { refrigeratorSelectedOption, onOptionSelect }: RefrigeratorOptionsProps,
    ref: ForwardedRef<HTMLDivElement>
) => {
    const { t } = useTranslation();
    return (
        <div ref={ref} className="appliance-options">
            <Button
                className={classNames({
                    selected: refrigeratorSelectedOption === REFRIGERATOR_OPTIONS.BROWSE_REFRIGERATORS,
                })}
                onClick={() => onOptionSelect(REFRIGERATOR_OPTIONS.BROWSE_REFRIGERATORS)}
            >
                {t('SCROLLABLE_AREA.REFRIGERATOR.OPTIONS.BROWSE_REFRIGERATORS')}
            </Button>

            <Button
                className={classNames('refrigerator-expansive-button', {
                    selected: refrigeratorSelectedOption === REFRIGERATOR_OPTIONS.SUPPLY_REFRIGERATORS,
                })}
                onClick={() => onOptionSelect(REFRIGERATOR_OPTIONS.SUPPLY_REFRIGERATORS)}
            >
                {t('SCROLLABLE_AREA.REFRIGERATOR.OPTIONS.SUPPLY_REFRIGERATORS')}
            </Button>

            <Button
                className={classNames({
                    selected: refrigeratorSelectedOption === REFRIGERATOR_OPTIONS.NO_REFRIGERATORS,
                })}
                onClick={() => onOptionSelect(REFRIGERATOR_OPTIONS.NO_REFRIGERATORS)}
            >
                {t('SCROLLABLE_AREA.REFRIGERATOR.OPTIONS.NO_REFRIGERATORS')}
            </Button>
        </div>
    );
};

export default forwardRef<HTMLDivElement, RefrigeratorOptionsProps>(RefrigeratorOptions);
